import { crowdedStateLabels, mapLabelConnectorProps, mapLabelStyle, usaHeatmapGeoUrl } from "./usaHeatmapConfig";
import { Annotation, ComposableMap, Geographies, Geography, ZoomableGroup, Marker  } from "react-simple-maps";
import { formatHeatmapDisplayValue } from "../../../utils/charts/heatmapValueFormat";
import { getHeatmapColor } from "../../../utils/charts/heatmapColorScale";
import React, { useMemo } from "react";
import { geoCentroid } from "d3-geo";

const MapChart = ({chartObject}) => {
  const colorRange = chartObject?.legend?.colorRange || [];
  const valueFormat = chartObject?.valueFormat;
  const legendRange = {
    min: Number(chartObject?.legend?.legendMin),
    max: Number(chartObject?.legend?.legendMax),
  };

  const valuesByDestinationState = useMemo(() => {
    const reportData = chartObject?.report?.data || [];

    return reportData.reduce((stateValues, item) => {
      if (item.DESTINATION_STATE) {
        stateValues[item.DESTINATION_STATE.toUpperCase()] = item.VALUE;
      }

      return stateValues;
    }, {});
  }, [chartObject]);

  const getStateValue = (mapStateName) => {
    const state = mapStateName.toUpperCase();
    return valuesByDestinationState[state];
  };

  const getColor = (mapStateName) => {
    const value = getStateValue(mapStateName);
    return getHeatmapColor(value, colorRange, legendRange);
  };

  const getRoundedValue = (mapStateName) => {
    const value = getStateValue(mapStateName);
    if (value === undefined) return null;
    return valueFormat ? formatHeatmapDisplayValue(value, valueFormat) : Math.round(value * 100) / 100;
  };

  const renderStateLabel = (stateName, centroid, value) => {
    const callout = crowdedStateLabels[stateName];

    if (callout) {
      return (
        <Annotation
          subject={centroid}
          dx={callout.dx}
          dy={callout.dy}
          connectorProps={mapLabelConnectorProps}
        >
          <text
            textAnchor={callout.anchor}
            dominantBaseline="middle"
            style={mapLabelStyle}
          >
            {value}
          </text>
        </Annotation>
      );
    }

    return (
      <Marker coordinates={centroid}>
        <text
          textAnchor="middle"
          dominantBaseline="middle"
          style={mapLabelStyle}
        >
          {value}
        </text>
      </Marker>
    );
  };

  return (
        <div className="heatmapChart" style={{ width:'100%', height:'100%' }}>
          <ComposableMap projection="geoAlbersUsa" 
            style={{ width: "100%", height: "100%" }}
          >
            <ZoomableGroup zoom={1}>
              <Geographies geography={usaHeatmapGeoUrl}>
                {({ geographies }) =>
                  geographies.map(geo => {
                    const centroid = geoCentroid(geo);
                    const rounded = getRoundedValue(geo.properties.name);
                    return (
                      <React.Fragment key={geo.rsmKey}>
                        <Geography
                          geography={geo}
                          fill={getColor(geo.properties.name)}
                          strokeWidth= {0.5}
                          stroke="#616161ff"
                        />
                         {rounded !== null && (
                          renderStateLabel(geo.properties.name, centroid, rounded)
                        )}
                      </React.Fragment>
                    );
                  })
                }
              </Geographies>
            </ZoomableGroup>
          </ComposableMap>
        </div>
  );
};

export default MapChart;
